import { useContext } from 'react';
import DataContext from '../contexts/DataContext';

class Security {
  static isInterviewer(meeting) {
    const { user } = useContext(DataContext);
    return meeting.interviewers.some((i) => i.id === user.id);
  }

  static isTeamMember(team) {
    const { user } = useContext(DataContext);
    return user.membership.some((m) => m.teamId === team.id);
  }

  static isProjectOwner(project) {
    const { user } = useContext(DataContext);
    return project.owners.some((owner) => owner.id === user.id);
  }

  static isDecibio() {
    const { user } = useContext(DataContext);
    if (!user.membership) return false;
    return user.membership.some((m) => m.teamName === 'Decibio');
  }

  static isSuperUser() {
    const { user } = useContext(DataContext);
    if (!user.membership) return false;
    return user.membership.some(
      (membership) => membership.teamName === 'Dexter' && membership.role === 'Admin',
    );
  }

  static isDoubleBlinded() {
    const { team } = useContext(DataContext);
    return team.isDoubleBlinded;
  }
}

export default Security;
